
declare var moment: any;
namespace Nobox {
    import Option = Serenity.Decorators.option;
    @Serenity.Decorators.registerEditor('Custom.AutoNumericEditor', [Serenity.IStringValue, Serenity.IReadOnly])
    @Serenity.Decorators.element('<input type="text"/>')
    export class AutoNumericEditor extends Serenity.Widget<any> implements Serenity.IDoubleValue, Serenity.IReadOnly {

        constructor(input: JQuery, opt: any) {
            super(input, opt);   
            var optionAuto = this.getCookie("formatnumber");
            if (optionAuto == null) {
                input.autoNumeric('init');
            } else {
                var formatnumber = JSON.parse(decodeURIComponent(optionAuto));
                if (jQuery.isEmptyObject(formatnumber)) {
                } else {
                    var obj = {};
                    if ('aDec' in formatnumber) {
                        obj["aDec"] = formatnumber["aDec"];
                    }
                    if ('mDec' in formatnumber) {
                        obj["mDec"] = formatnumber["mDec"];
                    }
                    if ('aSep' in formatnumber) {
                        obj["aSep"] = formatnumber["aSep"];
                    }
                    if ('dGroup' in formatnumber) {
                        obj["dGroup"] = formatnumber["dGroup"];
                    }
                    if ('lZero' in formatnumber) {
                        obj["lZero"] = formatnumber["lZero"];
                    }
                    input.autoNumeric('init', obj);
                }
            }
        }

        getCookie(name) {
            const value = `; ${document.cookie}`;
            const parts = value.split(`; ${name}=`);

            if (parts[1] == undefined) {
                return null;
            } else {
                return parts[1].split(';').shift();
            }
        }
        get_value(): number {
            var value = this.element.autoNumeric('get');
            if (value != null && value.length === 0) {
                return null;
            }
            return value;
        }

        get value(): number {
            return this.get_value();
        }

        set_value(value: number) {
            if (value != undefined) {
                this.element.autoNumeric("set", value);
            }
        }

        set value(v: number) {
            this.set_value(v);
        }

        get_readOnly(): boolean {
            return this.element.hasClass('readonly');
        }

        set_readOnly(value: boolean): void {

            if (value !== this.get_readOnly()) {
                if (value) {
                    this.element.addClass('readonly').attr('readonly', 'readonly');
                }
                else {
                    this.element.removeClass('readonly').removeAttr('readonly');
                }
            }
        }
    }

}